import Slider from "react-slick";
import FormConsultarDatosPatente from "./Formularios/FormConsultarDatosPatente";
import { useState } from "react";
import FormCompletarAprobarInfraccion from "./Formularios/FormAprobarDenunia";

const AprobarInfraccion = (props) => {
  const { infraccion_seleccionada, setInfraccionesNuevas } = props;
  const [datosTitular, setDatosTitular] = useState(null);

  const [zoomStyle, setZoomStyle] = useState({});

  const handleMouseMove = (e) => {
    const { offsetX, offsetY, target } = e.nativeEvent;
    const { width, height } = target;

    const xPos = (offsetX / width) * 100;
    const yPos = (offsetY / height) * 100;

    setZoomStyle({
      transform: `scale(1.5)`,
      transformOrigin: `${xPos}% ${yPos}%`,
    });
  };

  const handleMouseLeave = () => {
    setZoomStyle({
      transform: "scale(1)",
    });
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    appendDots: (dots) => (
      <div
        style={{
          backgroundColor: "transparent",
          borderRadius: "10px",
          padding: "10px",
        }}
      >
        <ul style={{ margin: "0px", padding: 0 }} className="d-flex justify-content-center gap-2"> {dots} </ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={{
          width: "30px",
          color: "blue",
          border: "1px blue solid",
        }}
      >
        <img src={infraccion_seleccionada.fotos[i].file} key={i} style={{ width: "100%" }} />
      </div>
    ),
  };



  return (
    <div className="slider-container ">
      {!datosTitular ? (
        <>
          {/* <hr className="m-0 mt-2 mb-1"/> */}
          <div className="" >
            <p className="m-0 text-center fw-bold text-primary"> Fotos de la infracción</p>
            <Slider {...settings} >
              {infraccion_seleccionada?.fotos?.map((foto, i) => (
                <div key={i}  >
                  <img
                    src={foto.file}
                    // className=" zoom-image mx-auto bg-primary"
                    className=" mx-auto"

                    alt="img-infraccion"

                    // onMouseMove={handleMouseMove}
                    // onMouseLeave={handleMouseLeave}
                    style={{ height: "450px", aspectRatio: "3/4", objectFit: "contain", background: "#c8c8c8", ...zoomStyle, }}

                  />
                </div>
              ))}
            </Slider>
          </div>
          {/* <hr />
          <FormConsultarDatosPatente
            infraccion_seleccionada={infraccion_seleccionada}
            setDatosTitular={setDatosTitular}
          /> */}
        </>
      ) : (
        <FormCompletarAprobarInfraccion
          setInfraccionesNuevas={setInfraccionesNuevas}
          infraccion_seleccionada={infraccion_seleccionada}
          datosTitular={datosTitular}
        />
      )}
    </div>
  );
};

export default AprobarInfraccion;
